export interface IResource {
  id: string;
  avatarUrl: string;
  name: string;
  description: string;
  extinctionUnit: string;
  type: string;
  note: any;
  createdAt: string;
  updatedAt: string;
}

export interface IResourceCreateDto {
  avatarUrl?: string | null;
  name?: string;
  description?: string;
  extinctionUnit?: string;
  type?: string;
  note?: any;
}

export enum ResourceType {
  NONE = "none",
  CONSUMERS = "consumers",
  ACCESSOIRES = "accessories",
}
